import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=2644d8e6&scoped=true&"
import script from "./Marquee.vue?vue&type=script&lang=js&"
export * from "./Marquee.vue?vue&type=script&lang=js&"
import style0 from "./Marquee.vue?vue&type=style&index=0&id=2644d8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644d8e6",
  null
  
)

export default component.exports